/**
 * GA4 module impression helper
 *
 * Usage:
 *   observeModuleImpression('.flagship-preheat-saving', 'deposit');
 *
 *   observeModuleImpression({
 *     selector: '.flagship-preheat-saving',
 *     moduleName: 'deposit',
 *     once: true,
 *     threshold: 0,
 *     eventParameters: { current_module_name: 'deposit' }
 *   });
 */
(function (window) {
  'use strict';

  function pushModuleImpression(eventParameters) {
    if (!window.dataLayer) {
      window.dataLayer = [];
    }

    window.dataLayer.push({ event_parameters: null });
    window.dataLayer.push({
      event: 'ga4Event',
      event_name: 'module_impression',
      event_parameters: eventParameters || {},
    });
  }

  function normalizeTargets(target) {
    if (!target) return [];
    if (typeof target === 'string') {
      return Array.prototype.slice.call(document.querySelectorAll(target));
    }
    if (target.nodeType === 1) {
      return [target];
    }
    if (typeof target.length === 'number') {
      return Array.prototype.slice.call(target);
    }
    return [];
  }

  function resolveOptions(arg1, arg2, arg3) {
    // observeModuleImpression(selector, moduleName, options?)
    if (typeof arg1 === 'string' || (arg1 && arg1.nodeType === 1) || (arg1 && typeof arg1.length === 'number')) {
      var optionsFromArgs = arg3 || {};
      var moduleName = typeof arg2 === 'string' ? arg2 : '';
      var eventParameters =
        arg2 && typeof arg2 === 'object'
          ? arg2
          : optionsFromArgs.eventParameters || {
              current_module_name: moduleName,
            };

      return {
        target: arg1,
        once: optionsFromArgs.once !== false,
        threshold: optionsFromArgs.threshold || 0,
        rootMargin: optionsFromArgs.rootMargin || '0px',
        eventParameters: eventParameters,
      };
    }

    // observeModuleImpression({ selector, moduleName, ... })
    var opts = arg1 || {};
    var resolvedModuleName = opts.moduleName || opts.current_module_name || '';
    return {
      target: opts.selector || opts.target,
      once: opts.once !== false,
      threshold: opts.threshold || 0,
      rootMargin: opts.rootMargin || '0px',
      eventParameters:
        opts.eventParameters ||
        (resolvedModuleName
          ? { current_module_name: resolvedModuleName }
          : {}),
    };
  }

  function observeModuleImpression(arg1, arg2, arg3) {
    if (typeof IntersectionObserver === 'undefined') return null;

    var options = resolveOptions(arg1, arg2, arg3);
    var targets = normalizeTargets(options.target);
    if (!targets.length) return null;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;

          pushModuleImpression(options.eventParameters);

          if (options.once) {
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold: options.threshold,
        rootMargin: options.rootMargin,
      }
    );

    targets.forEach(function (element) {
      observer.observe(element);
    });

    return observer;
  }

  window.observeModuleImpression = observeModuleImpression;
  window.pushModuleImpression = pushModuleImpression;
})(window);
